export default function DoubleCorrectIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <div className={className}>
      <svg
        width={`1em`}
        height={`1em`}
        viewBox="0 0 18 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0312 0.75L3.84375 6.9375L0.75 3.84389M16.5 0.75L10.3125 6.9375L8.66909 5.29416"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}
